<template>
  <controller-frame title="Characters" class="Characters" v-if="mode === 'characters'">
    <div class="tab" slot="nav">
      <a @click="tab = 'public'" :class="{ current: tab === 'public' }">一般</a>
      <a v-if="role > 5" @click="tab = 'private'" :class="{ current: tab === 'private' }">秘匿</a>
    </div>
    <div class="detail" v-if="role > 5">
      <h3 @click="edit = !edit">ステータス項目編集 <span v-text="edit ? '[閉じる]' : '[開く]'"></span></h3>
      <div v-if="edit">
        <!-- <div class="item">
          <input type="text" :value="'initiative'">
        </div> -->
        <div class="item">
          <div class="col">
            <label for="p-ini-key">ID</label>
            <input id="p-ini-name" class="input-key" type="text" value="dex" disabled>
          </div>
          <div class="col input-box">
            <label for="p-ini-name">表示名</label>
            <input id="p-ini-name" type="text" value="INITIATIVE" disabled>
          </div>
          <div class="col">
            <label for="p-ini-name">バー表示</label>
            <input type="checkbox" disabled>
          </div>
          <div class="remove">
            <faicon class="icon disabled" icon="trash" />
          </div>
        </div>
        <div class="item" v-for="(param, i) in characterParamList" :key="i">
          <div class="col">
            <label :for="`p-${i}-key`">ID</label>
            <input :id="`p-${i}-key`" class="input-key" type="text" :value="param.key" @change="(e) => setTextParam(e, 'key', i)">
          </div>
          <div class="col input-box">
            <label :for="`p-${i}-name`">表示名</label>
            <input :id="`p-${i}-name`" type="text" :value="param.name" @change="(e) => setTextParam(e, 'name', i)">
          </div>
          <div class="col">
            <label for="p-ini-name">バー表示</label>
            <input type="checkbox" :checked="param.flex" @change="(e) => setParam(!param.flex, 'flex', i)">
          </div>
          <div class="remove" @click="removeParam(i)">
            <faicon class="icon" icon="trash" />
          </div>
        </div>
        <a class="btn" @click="addParam()">ステータス項目追加</a>
        <!-- <div class="item">
          <input type="text" v-model="inputName">
          <input type="text" v-model="inputKey">
          <input type="checkbox" v-model="inputFlex">
          <button @click="addParam()">add</button>
        </div> -->
      </div>
    </div>
    <div class="container">
      <div class="character" @click="create">
        <figure class="image"><faicon icon="user-circle" /></figure>
        <p class="name m-ellipsis">新規作成</p>
      </div>
      <div class="character" v-for="character in characters" :key="character.key" @click="current(character.key)">
        <figure class="image"><img :src="src(character.imageKey)" draggable="false"></figure>
        <p class="name m-ellipsis">{{character.name}}</p>
      </div>
    </div>
  </controller-frame>
</template>

<script>
import controllerFrame from '../frames/controller'
export default {
  components: { 'controller-frame': controllerFrame },
  data() {
    return {
      isOwner: false,
      tab: 'public',
      edit: false
    }
  },
  computed: {
    mode() {
      return this.$store.getters['local/mode']
    },
    role() {
      return this.$store.getters['local/role']
    },
    characters() {
      const { tab } = this.$data
      if (tab === 'public') {
        return this.$store.getters['characters/$items'].filter((character) => {
          return !character.hidden
        })
      } else {
        return this.$store.getters['characters/$items'].filter((character) => {
          return character.hidden
        })
      }
    },
    src() {
      return this.$store.getters['images/getSrc']
    },
    characterParamList() {
      // console.log(this.$store.getters['room/characterParamList']);
      return this.$store.getters['room/characterParamList']
    }
  },
  methods: {
    async create() {
      const { tab } = this.$data
      this.$store.dispatch('characters/$create', { hidden: tab !== 'public' })
    },
    current(key) {
      this.$store.commit('characters/$checkout', key)
    },
    removeParam(i) {
      const list = this.characterParamList.concat([])
      list.splice(i, 1)
      this.$store.dispatch('room/$set', { key: 'characterParamList', value: list })
    },
    addParam() {
      const list = this.characterParamList.concat([])
      list.push({ name: '', key: ('0' + list.length).slice(-2), flex: false })
      this.$store.dispatch('room/$set', { key: 'characterParamList', value: list })
    },
    setTextParam(e, key, i) {
      const { currentTarget: { value } } = e
      const list = this.characterParamList.concat([])
      list[i][key] = value.slice(0, 5)
      this.$store.dispatch('room/$set', { key: 'characterParamList', value: list })
    },
    setParam(value, key, i) {
      // const { currentTarget: { value } } = e
      const list = this.characterParamList.concat([])
      list[i][key] = value
      this.$store.dispatch('room/$set', { key: 'characterParamList', value: list })
    }
  }
}
</script>

<style scoped>
.Characters {
  width: 280px;
  /*align-items: flex-start;*/
}
.owner {
  padding: 5px;
  display: block;
  font-size: 12px;
  background: rgba(0, 0, 0, 0.2);
}
.container {
  padding: 10px;
  display: flex;
  flex-wrap: wrap;
  align-content: flex-start;
}
.character {
  padding: 7px 7px 10px;
  cursor: pointer;
  width: 50px;
}
.character .image {
  border: 1px solid #fff;
  border-radius: 50%;
  box-sizing: border-box;
  overflow: hidden;
  display: flex;
  width: 50px;
  height: 50px;
  align-items: center;
  justify-content: center;
  background: #fff;
}
.character .image svg {
  width: 100%;
  height: 100%;
  color: #ccc;
}
.character .name {
  margin-top: 2px;
  text-align: center;
  font-size: 12px;
  font-weight: 800;
}
.tab {
  display: flex;
}
.tab a {
  border-bottom: 1px solid #222;
  flex: 1;
  text-align: center;
  padding: 5px;
  background: rgba(0, 0, 0, 0.2);
  font-size: 12px;
  color: #888;
}
.tab a.current {
  border-bottom: none;
  /* background: #222; */
  background: rgba(0, 0, 0, 0.4);
  color: #fff;
}
.tab a + a {
  border-left: 1px solid #222;
}
.detail {
  border-top: 1px solid #000;
  border-bottom: 1px solid #000;
}
.detail h3 {
  padding: 5px;
  font-size: 12px;
  cursor: pointer;
  background: rgba(0, 0, 0, 0.2);
}
.detail h3 span {
  margin-left: 5px;
  font-size: 10px;
  font-weight: normal;
}
.detail .item {
  border-bottom: 1px solid #222;
  display: flex;
}
.detail .item .col {
  display: flex;
}
.detail .item .col.input-box {
  flex: 1;
}
.detail .item .col label {
  padding: 6px 4px;
  border-left: 3px solid #000;
  background: #111;
  font-size: 10px;
  color: #444;

}
.detail .item .col input[type="text"] {
  flex: 1;
  border: 1px solid #111;
  border-radius: 0;
}
.detail .item .col input[type="text"][disabled] {
  color: #444;
}
.detail .item .col input[type="text"].input-key {
  flex: none;
  width: 42px;
}
.detail .item .col input[type="checkbox"] {
  margin: 7px;
}
.detail .item .remove {
  background: #000;
  cursor: pointer;
}
.detail .item .remove .icon {
  padding: 0 8px;
  position: relative;
  width: 8px;
  height: 8px;
}
.detail .item .remove .icon.disabled {
  color: #222;
}
.btn {
  padding: 7px;
  display: block;
  background: rgba(0, 0, 0, 0.4);
  font-size: 10px;
  text-align: center;
}
.btn:hover {
  background: rgba(0, 0, 0, 0.2);
}
</style>
